module.exports = __webpack_public_path__ + "img/loading2.4dd80cab.gif";